
import { defineComponent } from 'vue'
import BetModal from './BetModal.vue'
import Button from './Button.vue'

export default defineComponent({
    name: 'VoteButton',
    components: {
        BetModal,
        Button
    },
    data() {
        return {
            showBetModal: false
        }
    },
    props: {
        text: String,
        color: String,
        teamName: String,
        dapp: Object,
    },
    methods: {
        toggleBetModal: function() {
            this.showBetModal = !this.showBetModal;
        }
    }
})
